var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Link',{staticClass:"category-card",attrs:{"path":_vm.link}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.data[`name${_vm.$t('k')}`]))]),_c('img',{staticClass:"cover",attrs:{"src":_vm.data.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }